import { v4 as uuidv4 } from 'uuid';

import { dispatchPromise, fetchResources } from './action-helpers';

const DEFAULT_LABEL_PROPS = {
    id: null,
    type: 'others',
    name: '',
    color: ''
};

export const createLabel = labelProps => {
    return dispatchPromise({
        type: 'LABEL_CREATE_REQUESTED',
        payload: {
            label: Object.assign({}, DEFAULT_LABEL_PROPS, labelProps, {
                id: uuidv4()
            })
        }
    });
}

export const fetchLabels = all => fetchResources('LABELS_FETCH_REQUESTED', {}, all);

export const fetchLabel = labelId => {
    return dispatchPromise({
        type: 'LABEL_FETCH_REQUESTED',
        payload: { labelId }
    });
}

export const updateLabel = (labelId, labelProps, preventSave) => {
    return dispatchPromise({
        type: 'LABEL_UPDATE_REQUESTED',
        preventSave,
        payload: {
            labelId,
            labelProps
        }
    });
}

export const removeLabel = labelId => {
    return dispatchPromise({
        type: 'LABEL_REMOVE_REQUESTED',
        payload: {
            labelId
        }
    });
}
